import { Component, Input, OnInit ,EventEmitter, Output} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Globals } from 'projects/core/src/globals';
import { CustomField, Filter, FilterMode } from 'projects/core/src/include/structures';
import { CustomfunctionsService } from 'projects/core/src/lib/customfunctions.service';
import { VerifyFiscalCodeService } from 'projects/core/src/lib/verify-fiscal-code.service';
import { UploadFileComponent } from '../../upload-file/upload-file.component';
import { ImportCustomfieldsComponent } from '../import/import.component';
import { AddressDetailsComponent } from 'projects/c1-backend/src/app/views/address/address-details/address-details.component';
import { AddressComponent } from 'projects/c1-backend/src/app/views/address/address.component';
import { CustomfieldsService } from 'projects/core/src/lib/customfields.service';
import { ModelList } from 'projects/core/src/include/modellist';
import { CustomfieldssettingsDetailComponent } from 'projects/core/src/settings/customfields-settings/detail/detail.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-customfields2',
  templateUrl: './list.component.html',
  styleUrl: './list.component.css'
})
export class ListCustomfieldsComponent extends ModelList<CustomField> implements OnInit {
  @Input()
  layout="horizontal"

   @Input()
  record_source:any;

  @Output()
  customfieldsLoaded:EventEmitter<any>=new EventEmitter();

  filter_status:Filter=new Filter();
  filter_table:Filter=new Filter();
  filter_id_addresses:Filter=new Filter();
  filter_condition_id:Filter<string[]>=new Filter<string[]>();
  filter_condition_field:Filter<string[]>=new Filter<string[]>();
  filter_tag:Filter=new Filter();

  multi_value_input:string;

  @Input()
  origin:any={};

  @Input()
  id_table:number;

  @Input()
  table:string;

  @Input()
  list:CustomField[]=[];

  @Input()
  condition_id:number=0;

  @Input()
  condition_field:string;

  @Input()
  tag:string;

  @Input()
  access:string="superuser,admin,manager";

 

  mode="embedded";
  listvalue:CustomField[]=[];


  tax_code_error:string="";
  vat_number_error:string="";

  enable_editing=false;
  isFilterSet=false;
  constructor(
    private customfieldsService: CustomfieldsService,
    private fb1: UntypedFormBuilder,
    private customfunctionsService:CustomfunctionsService,
  ){
    super(customfieldsService,fb1);
   }

  ngOnInit(): void {
    
    if(typeof(this.list)=="string")
      this.list={} as CustomField[];
    
      

    
  }

  setFilters():void{
    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("c.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);

    this.filter_table.mode=FilterMode.normal;
    this.filter_table.fields=[];
    this.filter_table.fields.push("c.table");
    this.filter_table.value=this.table;
    this.filter.push(this.filter_table);


    this.filter_condition_field.mode=FilterMode.contain;
    this.filter_condition_field.fields=[];
    this.filter_condition_field.fields.push("c.condition_field");
    this.filter.push(this.filter_condition_field);

    this.filter_condition_id.mode=FilterMode.contain;
    this.filter_condition_id.fields=[];
    this.filter_condition_id.fields.push("c.condition_id");
    this.filter.push(this.filter_condition_id);

    if(this.tag!=""){
      this.filter_tag.mode=FilterMode.normal;
      this.filter_tag.fields=[];
      this.filter_tag.fields.push("c.tag");
      this.filter_tag.value=this.tag;
      this.filter.push(this.filter_tag);
    }


    this.isFilterSet=true;
    
  }

  ngOnChanges():void{
    
    //effettua una copia dei valori 
    if(this.list!=undefined)
      //if(this.listvalue.length==0)
        this.listvalue  = this.list.map(x => Object.assign({}, x));
        
    this.updateList();
  }

  updateList():void{

    if(this.id_table==null)
      return;
    this.paging_count=100;
    
    if(!this.isFilterSet)
      this.setFilters();
      
    if(this.condition_id!=undefined){
      this.filter_condition_id.value=[];
      this.filter_condition_id.value.push(this.condition_id.toString());
      this.filter_condition_id.value.push(""); //così prende anche tutti i customfield che non sono stati esplicitati in questi campi
      
      


      this.filter_condition_field.value=[];
      this.filter_condition_field.value.push(this.condition_field);
      this.filter_condition_field.value.push(""); //così prende anche tutti i customfield che non sono stati esplicitati in questi campi

      
    }

    this.ordering.field="c.ordering";

      this.customfieldsService.getCustomFields(this.table,false).subscribe((items:CustomField[])=>{
      //this.getItems((items:CustomField[])=>{
        if(this.list==undefined)
          this.list=[];
        else  
          //azzera la lista
          this.list.splice(0,this.list.length);
        
        //aggiungi ogni customfield del template e verifica se avevi dei valori da inserirci
        for (let item of items){
          let i:any={};
          Object.assign(i,item);

          if(i.access.indexOf(Globals.user.role)>-1 || i.access=="all"){
              //parserizza le opzioni
              if(i.params==null){
                i.params=[];
              }
              else{
                try{
                  if(typeof(i.params)=="string")
                    i.params=JSON.parse(i.params);
                }catch{
                  i.params=[];
                }
              }
              
            
            if(i.type=="address"){
              i.value={"name":"","id_address":0}
            }
            
            //cerca i valori dentro listvalue
            let c:CustomField=this.listvalue.filter(r=>r.id==i.id)?this.listvalue.filter(r=>r.id==i.id)[0]:null;
            if(c!=null){
              
              if(c.type=="select"){
                //parserizza le opzioni
                if(c.params==null)
                  i.params=[];
                else{
                  try{
                    if(typeof(c.params)=="string")
                      i.params=JSON.parse(c.params);
                    else
                      i.params=c.params;

                  }catch{
                    i.params=[];
                  }
                }
              }

              if(c.type=="address"){
                try{
                  c.value=JSON.parse(c.value);
                }catch{
                  c.value={
                    "name":"",
                    "id_address":0
                  }
                }
              }

              i.value=c.value;
              
            }
            
            /*
            if(i.value==null)
              if(i.tag=="features" && i.type=="select")
                i.value=[];
            */
            this.list.push(i);
          }
   
       } 
       this.customfieldsLoaded.emit(this.list);
      
      });
    //},false);
  }

  addTextOnMulti(record:CustomField){
    let result=prompt("Inserisci il valore");
    if(result!=""){
      let array:string[]=[];
      if(record.value==undefined)
        record.value="";
      else
        array=record.value.split("|");
      array.push(result);

      record.value=array.join("|");
    
    }
  }

  removeTextOnMulti(record:CustomField,value:string){
    let array:string[]=[];
    array=record.value.split("|");
    for(let i=0;i<array.length;i++)
      if(array[i]==value){
        array.splice(i,1);
        
      }

    if(array.length>0)
      record.value=array.join("|");
    else
      record.value="";
  }



  verifyTaxCode(record:CustomField):boolean{

    let verifyFiscalCode=new VerifyFiscalCodeService();
    let v:boolean=false;
    this.tax_code_error="";
    if(record.value!=undefined){
      v=verifyFiscalCode.validate(record.value);
      if(!v)
        this.tax_code_error=verifyFiscalCode.error_message;
    }
    return v;
  }

  counterClass=0;

  get divisor():boolean{
    if(this.counterClass>=8){
      this.counterClass=0;
      return true;
    }else{
      return false;
    }
  };

  calculateClassSize(type){
    switch(type){
      case "checkbox":
      case "number":
      case "currency":
        this.counterClass=this.counterClass+4;
        return 2;

      case "date":
      case "select":
        this.counterClass=this.counterClass+5;
          return 3;

      case "text":
      case "tax_code":
      case "url":
        this.counterClass=this.counterClass+6;
          return 4;
      case "separator":
        this.counterClass=0;
        return 12;


    }
  }


  isListValid(){
    if(Array.isArray(this.list))
      return true;
    return false;
  }

  getBasePath(path){
    if(path)
      return Globals.config.serverUrl+"/"+path;
    return "";
  }

  downloadFile(relative_path){
    window.open( this.getBasePath(relative_path),"_blank");
  }

  uploadFile(field){
    Globals.modal.showModal(UploadFileComponent,[
      {"name":"record","value":field},
      {"name":"params","value":field.params},

    ],(instance)=>{

      if(instance){
        field.value=instance['filename'];
      }
    },"md");
  }
  
  runCustomFunction(id_function,value){
    this.customfunctionsService.executeFunction(id_function,value).subscribe((result)=>{
      value=result;
    })
  }


  openImport(){
    Globals.modal.showModal(ImportCustomfieldsComponent,[{"name":"mode","value":"modal"},{"name":"table","value":this.table}],(instace)=>{});
  }

  selectAddress(field:any){
    var id_type=0;
    if(field){
      if(!Array.isArray(field.option)){
        try{
          field.option=JSON.parse(field.option);
        }catch{
          field.option=[];
        }
      }
      
      if(Array.isArray(field.option)){
        for(let p of field.option){
          if(p.name=="id_type")
            id_type=parseInt(p.value);
        }
      }
    }
        
  
    Globals.modal.showModal(AddressComponent,[
      {"name":"mode","value":"modal"},
      {"name":"resetState","value":true},
      {"name":"id_type","value":id_type},
      
    ],(instance:any)=>{
      if(instance!=null){
        field.value={"name":instance['recordSelected'].name,"id":instance['recordSelected'].id};
      }
    })
  }
    openAddress(id:number){
      Globals.modal.showModal(AddressDetailsComponent,[
        {"name":"mode","value":"modal"},
        {"name":"id","value":id}
      ],(instance:any)=>{
        
      })
    }
    unlinkAddress(record:any){
      record.value="";
    }


    addSelectValue(field:any){
      let message=prompt("Inserisci l'etichetta da aggiungere");
      if(message){
        field.option.push({"item":message});
        let r:any={id:field.id,option:field.option}
        this.customfieldsService.save(r,()=>{
          field.value=message;
        });
      }
    }
  


    isAgreed(field:any){
      if(field.access){
        
        
        if(field.access=="all"){
          return true;
        }

        if(field.access==""){
          return false;
        }

        try{
          if(typeof(field.access)=="string")
            field.access=JSON.parse(field.access);

          let group=field.access.filter((x:any)=>x.group==Globals.user.role);
         
          if(group.length>0){
            if(group[0].permission=="read" || group[0].permission=="all"){
              return true;
            }
          }

        }catch{
          return false;
        }

      }

      return true;
    }


    editInRow(record:any,idx:number){
      Globals.modal.showModal(CustomfieldssettingsDetailComponent,[
        {"name":"mode","value":"modal"},
        {"name":"id","value":record['id']}
      
      ],(instance:any)=>{
        if(instance){
          this.list[idx]=instance.record;
          this.list[idx].value=record.value;
        }
      })
    }

    addCustomField(){
      Globals.modal.showModal(CustomfieldssettingsDetailComponent,[
        {"name":"mode","value":"modal"},
        {"name":"table","value":this.table}
      
      ],(instance:any)=>{
        if(instance){
          instance.record.value="";
          this.list.push(instance.record);
        }
      })
    }

    isSuperUser(){
      return Globals.user.isSuperUser();
    }



    @Output() orderChanged = new EventEmitter<any[]>();

  onDrop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) { return; }

    // Gli indici del drop sono relativi ai soli record visibili (isAgreed).
    // Li converto negli indici reali dentro this.list.
    const visible = this.list.filter(r => this.isAgreed(r));
    const movedRecord  = visible[event.previousIndex];
    const targetRecord = visible[event.currentIndex];

    const from = this.list.indexOf(movedRecord);
    const to   = this.list.indexOf(targetRecord);

    moveItemInArray(this.list, from, to);

    // Ricalcolo il campo ordering per tutta la lista
    this.list.forEach((record, idx) => record.ordering = idx + 1);

    this.saveOrdering();
  }

  saveOrdering() {
    // Payload minimale: solo id e nuovo ordering
    const payload:any[] = this.list.map(r => ({
      id: r.id,
      ordering: r.ordering,
      table:r.table
    }));

    this.customfieldsService.saveMultiple(payload,()=>{

    },false)
  }


  checkEnableCondition(fields:any[],enable_condition_fieldname:string | null,defaultvalue:any | null,access:any){
    
    //if(access==0) return false; //TODO da controllare
   
    if(enable_condition_fieldname){
       
      for(let f of fields){
        if(f.name==enable_condition_fieldname){

          if(defaultvalue==null || defaultvalue==""){
            if(f.value=='' || f.value==0 || f.value==undefined || f.value==null){
              
              return false;
            }
          }else{
            let v=[];
            if(Array.isArray(defaultvalue)){
              v=defaultvalue
            }else{
              if(typeof(defaultvalue)=="string"){
                v=defaultvalue.split(";");
              }
            }
            
            
            if(v.indexOf(String(f.value))==-1)
              return false
          }
    
        }
      }
    }

    return true;
  }
}
